import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

const OtpPopup = ({ isOpen, onClose, onSubmit }) => {
  const [otp, setOtp] = useState(["", "", "", ""]);

  const handleChange = (value, index) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Focus on the next input if not the last
    if (value && index < 3) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const handleSubmit = () => {
    const otpValue = otp.join("");
    onSubmit(otpValue);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50 font-Poppins">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-lg relative">
        {/* Close Icon */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
        >
          <AiOutlineClose size={28} />
        </button>

        {/* Title */}
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">
          Enter OTP
        </h2>
        <p className="text-gray-600 text-center text-base mb-8">
          We’ve sent a 4-digit OTP to your mobile number.
        </p>

        {/* OTP Inputs */}
        <div className="flex justify-center gap-6">
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-16 h-16 text-center text-2xl font-bold border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400"
            />
          ))}
        </div>

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          className="w-full mt-8 py-3 bg-yellow-400 text-white font-semibold rounded-lg hover:bg-gray-800 transition-colors text-lg"
        >
          Verify OTP
        </button>
      </div>
    </div>
  );
};

export default OtpPopup;
